import { cn } from "../../utils/cn";

interface AvatarProps extends React.ComponentProps<"img"> {}

export function Avatar({ className, ...rest }: AvatarProps) {
  return <img className={cn("h-8 w-8 rounded-full", className)} {...rest} />;
}
